import React, { Component } from 'react';

export default class Progress extends Component {
	render() {
		if (!this.props.visible) return null;

		return (
			<div className='Progress--holder'>
				<div className='Progress--content'>
					{
						this.props.waitBox === false ? null : <span className={`spinning fa fa-circle-o-notch ${this.props.extraClass?this.props.extraClass:''}`} />
					}
				</div>
			</div>
		);
	}
}
